<template>
    <div class="TQ_height_bodyFullScreen2 TQ_grid_row_1frAuto TQ_center">

        <!-- camture-->
        <div v-show="haveCamera_b && store_system_requestCameraPermission_b.val && !dontHaveCameraPermission_b" class="TQ_height_100p">

            <!--<img v-show="cameraMode_e === enum_cameraVideoModes.finishRecord && blobUrl_imgCapture_s" ref="ref_captureImage" class="class_temp"/>-->
            <video v-show="[enum_cameraVideoModes.preRecords, enum_cameraVideoModes.recording].includes(cameraMode_e)"
                   ref="video"
                   width="100%"
                   autoplay
                   class="TQ_height_100p">
            </video>

            <video v-show="[enum_cameraVideoModes.finishRecord].includes(cameraMode_e)"
                   ref="videoEdit"
                   width="100%"
                   autoplay
                   class="TQ_height_100p"
                   controls>
            </video>

        </div>

        <!-- no camera-->
        <div v-show="!haveCamera_b || !store_system_requestCameraPermission_b.val || dontHaveCameraPermission_b" class="TQ_grid_verticalCenter">

            <!-- dont have camera-->
            <div v-if="!haveCamera_b"
                 class="TQ_text_28px TQ_text_bold">
                {{ass_strings.twoWords_noCamera[store_system_langCode_ve.val]}}
            </div>

            <div v-else-if="dontHaveCameraPermission_b"
                 class="TQ_text_28px TQ_text_bold">
                {{ass_strings.threeWords_noCameraPermission[store_system_langCode_ve.val]}}
            </div>

            <!-- get camera permission -->
            <tq-btn-approve
                    v-else-if="!store_system_requestCameraPermission_b.val"
                    btn-class="TQ_btn TQ_text_bold TQ_bg_gold TQ_margin_4px TQ_text_capitalize TQ_text_28px "
                    :system-lang-code="store_system_langCode_ve.val"
                    :text="ass_strings.fourWords_turnOnTheCamera"
                    :popup-text="ass_strings.question_turnOnCamera"
                    :approve-cb="m_startCamera_f">
            </tq-btn-approve>

        </div>

        <!-- camera buttons -->
        <div class="TQ_bg_gray1 classBottom TQ_height_100px ">

            <div class=" TQ_grid_col_1frAuto1fr TQ_height_100p"
                 v-if="[enum_cameraVideoModes.preRecords, enum_cameraVideoModes.recording].includes(cameraMode_e)">
                <img :src="ass_img_flash_w"
                     @click="m_flashToggle_f"
                     class="TQ_width_32px TQ_grid_verticalCenter TQ_center"/>

                <img v-if="cameraMode_e === enum_cameraVideoModes.preRecords"
                     :src="ass_img_cameraBtn_beforeRecording"
                     @click="m_startVideoRecord_f"
                     class="cameraBtn TQ_width_52px TQ_border TQ_bg_circle TQ_border_white_4px TQ_padding_4px TQ_margin_12px TQ_grid_verticalCenter" />
                <si_-camera-button
                        @click.native="m_captureVideo_f"
                        v-else-if="cameraMode_e === enum_cameraVideoModes.recording"
                        class="cameraBtn TQ_width_52px TQ_grid_verticalCenter"
                        :p_max-time_n="gv_numbers.max_videoTimeInSeconds"
                        :p_time-passed_n="recordDurationInSeconds_n"/>

                <img :src="ass_img_gallery_w"
                     v-show="cameraMode_e === enum_cameraVideoModes.preRecords"
                     @click="m_gallery_f"
                     class="TQ_width_32px TQ_grid_verticalCenter TQ_center"/>
            </div>



            <div v-else-if="cameraMode_e === enum_cameraVideoModes.finishRecord" class="TQ_grid_col_1fr1fr TQ_height_100p">
                <img :src="ass_img_closeRed"
                     @click="cameraMode_e = enum_cameraVideoModes.preRecords"
                     class="TQ_width_40px TQ_grid_verticalCenter TQ_center"/>
                <img :src="ass_img_checked"
                     @click="() => {}"
                     class="TQ_width_40px TQ_grid_verticalCenter TQ_center"/>
            </div>
        </div>

        <!-- hide elements -->
        <div v-show="false">
            <!-- canvas -->
            <canvas ref="canvas"
                    style="width: 100%; height: 100%; display: none;"></canvas>

            <!-- input file -->
            <input type="file"
                   @change="m_userEvents_chooseFile_f($event)"
                   style="display: none;"
                   accept="video/*"
                   ref="inputFile">
        </div>

    </div>
</template>

<script>
    import {
        ass_img_camera_b, ass_img_camera_w,
        ass_img_cameraBtn_beforeRecording, ass_img_checked, ass_img_closeRed,
        ass_img_flash_w,
        ass_img_gallery_b,
        ass_img_gallery_w, ass_img_video_w, ass_img_cameraBtn_recording
    } from "../../assets/scripts/Ass_Files";
    import TqOnTopContainer from "../../components/basic/TqOnTopContainer";
    import {
        navigator_getVideoStream_f,
        navigator_videoStream_stop_f
    } from "../../scripts/S_Navigator";
    import TqBtnApprove from "../../components/basic2/TqBtnApprove";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import {store_getStateValue_vo, store_setStateValue, store_var} from "../../store";
    import {notification_notify} from "../../scripts/S_Notification";
    import {date_doEveryClockTick_addCb_f, date_doEveryClockTick_removeCb_f} from "../../scripts/S_Date";
    import {format_sizeBytes_s} from "../../../functions/src/shareCode/Share_S_Format";
    import {gv_numbers} from "../../../functions/src/shareCode/Share_Ass_GlobalVirables";
    import Si_CameraButton from "../../components/a_smartIcons/si_CameraButton";
    import {enum_cameraVideoModes} from "../../../functions/src/shareCode/Share_S_Enum";
    import {route_refreshPage_force} from "../../router";

    export default {
        name: "v_Ongoing_Camera",
        components: {Si_CameraButton, TqBtnApprove, TqOnTopContainer},
        data(){
            return {
                haveCamera_b : true,
                cameraMode_e : enum_cameraVideoModes.preRecords,
                captureImage : true,
                blobUrl_imgCapture_s : null,
                dontHaveCameraPermission_b : undefined,
                mediaRecorder_o : null,
                recordDurationInSeconds_n: 0,

                // store
                store_system_langCode_ve : store_getStateValue_vo(store_var.system_langCode),
                store_system_requestCameraPermission_b : store_getStateValue_vo(store_var.system_requestCameraPermission_b),

                // imports
                enum_cameraVideoModes : enum_cameraVideoModes,
                gv_numbers : gv_numbers,
                format_sizeBytes_s: format_sizeBytes_s,
                ass_img_cameraBtn_beforeRecording : ass_img_cameraBtn_beforeRecording,
                ass_img_cameraBtn_recording : ass_img_cameraBtn_recording,
                ass_img_flash_w : ass_img_flash_w,
                ass_img_gallery_w : ass_img_gallery_w,
                ass_img_camera_w : ass_img_camera_w,
                ass_img_video_w : ass_img_video_w,
                ass_img_closeRed : ass_img_closeRed,
                ass_img_checked : ass_img_checked,

                ass_strings : ass_strings,
            }
        },
        methods:{

            m_gallery_f(){
                this.$refs.inputFile.click()
            },
            m_userEvents_chooseFile_f(event){
                let blob = event.target.files[0]

                if(blob == null) return;

                if(blob.size > gv_numbers.maxFileSizeInByte){
                    notification_notify(ass_strings.oneWord_error, ass_strings.fourWords_fileIsTooBig)
                    return
                }

            },
            m_startCamera_f(){


                // listen to camera
                navigator_getVideoStream_f(
                    false,
                    (stream) => {
                        store_setStateValue(store_var.system_requestCameraPermission_b, true)
                        this.$refs.video.srcObject = stream;
                        this.mediaRecorder_o = new MediaRecorder(stream, {
                            audioBitsPerSecond  : 4000000,
                            videoBitsPerSecond  : 4000000,
                        });
                    },
                    () => {
                        this.dontHaveCameraPermission_b = true
                    },
                    () => {
                        this.haveCamera_b = false
                    })

            },
            m_startVideoRecord_f(){
                this.cameraMode_e = enum_cameraVideoModes.recording
                this.mediaRecorder_o.start();
                date_doEveryClockTick_addCb_f(this.$options.name, () => {
                    this.recordDurationInSeconds_n ++
                    if(this.recordDurationInSeconds_n >= gv_numbers.max_videoTimeInSeconds){
                        date_doEveryClockTick_removeCb_f(this.$options.name)
                    }
                }, false )
            },
            m_captureVideo_f(){
                this.mediaRecorder_o.ondataavailable = (e) => {
                    let blob = e.data
                    console.log(format_sizeBytes_s(blob.size))
                    this.$refs.videoEdit.src = URL.createObjectURL(blob);
                }
                this.mediaRecorder_o.stop();
                this.cameraMode_e = enum_cameraVideoModes.finishRecord
                date_doEveryClockTick_removeCb_f(this.$options.name)
            },
            m_flashToggle_f(){
                let video = this.$refs.video
                video.srcObject.applyConstraints({
                    advanced: [{torch: true}]
                });
            },

            // old
            m_captureImage_f(){

                let video = this.$refs.video
                let canvas = this.$refs.canvas
                let context = canvas.getContext("2d");

                if (video.readyState === video.HAVE_ENOUGH_DATA) {
                    // Load the video onto the canvas
                    canvas.width = video.videoWidth;
                    canvas.height = video.videoHeight;
                    context.drawImage(video, 0, 0);

                    canvas.toBlob((blob) =>{
                        this.$refs.ref_captureImage.src=URL.createObjectURL(blob)
                        this.blobUrl_imgCapture_s = URL.createObjectURL(blob);
                    })
                }
            },

            test(){
                route_refreshPage_force();
            }

        },
        mounted(){

            if(this.store_system_requestCameraPermission_b.val){
                this.m_startCamera_f()
            }


        },
        destroyed(){
            navigator_videoStream_stop_f()
        }
    }
</script>

<style scoped>


    .class_temp{
        width: 100%;
        height: 100%;
    }

    .classBottom{
        box-shadow: 0 12px 8px 16px rgba(0,0,0,0.2);
    }

</style>